import showdown from 'showdown';

showdown.setOption('disableForced4SpacesIndentedSublists', true);
showdown.setOption('simpleLineBreaks', true);
showdown.setOption('tables', true);

const converter = new showdown.Converter();

const markdownify = (value) => converter.makeHtml(value);

const useMarkdownify = () => ({
  markdownify,
});

export { markdownify, useMarkdownify };
